import React from "react";
import MainLayout from "../../common/MainLayout";
import { Box, CssBaseline } from "@mui/material";
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";

const Reports = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Header mainTitle={"Reports"} />
      <Sidebar />
      <MainLayout>
        <h1>Reports</h1>
      </MainLayout>
    </Box>
  );
};

export default Reports;
